export default __webpack_public_path__ + "beta-maps-guides-migrate-approximate-location-960-55b5b5c909fb978deda228a51bfdf05b.webp";